/**
 * API and WebSocket endpoint resolution.
 *
 * A production build is served from the same origin as the API — every app
 * vhost proxies /api (and /app for Reverb) to the backend — so one build serves
 * every product domain: app.boost.express, mymatch.express, ... Absolute
 * VITE_API_* values are only for the vite dev server, which has no /api proxy.
 */

const isDevServer = import.meta.env.DEV;

export const apiBaseUrl = isDevServer ? (import.meta.env.VITE_API_URL as string) : '/api';

export const apiUrl = (path: string): string => `${apiBaseUrl}${path}`;

export const wsHost = isDevServer
  ? (import.meta.env.VITE_API_PUSHER_HOST as string)
  : window.location.hostname;

export const wsAuthEndpoint = isDevServer
  ? (import.meta.env.VITE_API_PUSHER_AUTH_ENDPOINT as string)
  : `${apiBaseUrl}/broadcasting/auth`;
